import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const changedArray = function () {
  let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return a.length !== b.length || a.some((item, index) => !Object.is(item, b[index]));
};
const initialState = {
  error: null,
  locationPathName: null
};
class ErrorBoundary extends React.Component {
  constructor() {
    var _this;
    super(...arguments);
    _this = this;
    this.state = initialState;
    this.resetErrorBoundary = function () {
      var _a, _b;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_b = (_a = _this.props).onReset) == null ? void 0 : _b.call(_a, ...args);
      _this.reset();
    };
  }
  static getDerivedStateFromError(error) {
    return {
      error,
      locationPathName: window.location.pathname
    };
  }
  static getDerivedStateFromProps(_, state) {
    if (state.error !== null && state.locationPathName !== window.location.pathname) {
      return initialState;
    }
    return state;
  }
  reset() {
    this.setState(initialState);
  }
  componentDidCatch(error, info) {
    var _a, _b;
    (_b = (_a = this.props).onError) == null ? void 0 : _b.call(_a, error, info);
  }
  componentDidUpdate(prevProps, prevState) {
    var _a, _b;
    const {
      error
    } = this.state;
    const {
      resetKeys
    } = this.props;
    if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
      (_b = (_a = this.props).onResetKeysChange) == null ? void 0 : _b.call(_a, prevProps.resetKeys, resetKeys);
      this.reset();
    }
  }
  render() {
    const {
      error,
      locationPathName
    } = this.state;
    const {
      fallbackRender,
      FallbackComponent,
      fallback
    } = this.props;
    if (error !== null && locationPathName === window.location.pathname) {
      const props = {
        error,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (React.isValidElement(fallback)) {
        return fallback;
      } else if (typeof fallbackRender === "function") {
        return fallbackRender(props);
      } else if (FallbackComponent) {
        return /* @__PURE__ */jsx(FallbackComponent, __spreadValues({}, props));
      } else {
        throw new Error("react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop");
      }
    }
    return this.props.children;
  }
}
function withErrorBoundary(Component, errorBoundaryProps) {
  const Wrapped = props => {
    return /* @__PURE__ */jsx(ErrorBoundary, __spreadProps(__spreadValues({}, errorBoundaryProps), {
      children: /* @__PURE__ */jsx(Component, __spreadValues({}, props))
    }));
  };
  const name = Component.displayName || Component.name || "Unknown";
  Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
  return Wrapped;
}
function useErrorHandler(givenError) {
  const [error, setError] = React.useState(null);
  if (givenError != null) throw givenError;
  if (error != null) throw error;
  return setError;
}
export { ErrorBoundary, useErrorHandler, withErrorBoundary };